


































import { Component, Vue } from "vue-property-decorator";
import { ISideMenuItem } from "@/models/menus/isidemenu";

@Component
export default class UsersConfigurationPage extends Vue {
  // TODO: Change Icons
  routes: ISideMenuItem[] = [
    {
      icon: "las la-cog",
      title: "Gestão de Tipos",
      url: "/users/configurations/types"
    }
  ];
}
